import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "./page.css";
import ThankYou from "../assets/ThankYou.jpg";

const ContestThankYou = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const QRDATA = location.state?.QRData || "";
  useEffect(() => {
    // Simulating loading with setTimeout
    setTimeout(() => {
      setLoading(false); // Data has loaded, set loading to false
    }, 1000);
  }, []);

  return (
    <>
      <div className="container genuine mt-2">
        <div className="card">
          <div className="container fakee">
            <div className="row card-effects justify-content-center">
              <div className="card">
                {/* <div className="">
                  <h5 className="card-title">Congratulation!</h5>
                  <p className="card-textc">
                    Thank You for Participating in the Contest
                  </p>
                </div> */}
                <div className="row m-2">
                  <div
                    className="col-lg-12"
                    style={{ marginTop: "15px", marginBottom: "15px" }}
                  >
                    <img
                      className="d-block img-fluid border p-3"
                      src={ThankYou}
                      alt="genuine"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer Start */}
      <div className="footermy wow fadeIn" data-wow-delay="0.3s">
        <div className="container copyright">
          <div className="row">
            <div className="col-md-6 text-white copyright">
              {" "}
              © {new Date().getFullYear()} Optimum Nutrition, INC{" "}
            </div>
            <div className="col-md-6 text-right copyright designedby">
              Design & Developed by{" "}
              <a
                href="https://holostik.com/"
                className="desinged-by"
                target="_blank"
              >
                Holostik India Limited
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Footer End */}
    </>
  );
};

export default ContestThankYou;
